import { formatSpecifier } from 'd3-format';

import { VEGA_LITE_MAX_RESOURCE_COUNT } from './vega-lite-resource-limits';

export const VEGA_LITE_MAX_NUMERIC_FORMAT_WIDTH = VEGA_LITE_MAX_RESOURCE_COUNT;

export type VegaLiteNumericFormatIssue = {
  kind: 'literal' | 'syntax' | 'width';
  message: string;
};

/** Parse only: calling a formatter before checking its width could allocate the padded string. */
export function getVegaLiteNumericFormatIssue(
  value: unknown,
): VegaLiteNumericFormatIssue | undefined {
  if (typeof value !== 'string') {
    return {
      kind: 'literal',
      message:
        'A numeric format must be a D3 format string literal, such as ".2f" or ",.0f". Computed format specifiers are not supported.',
    };
  }

  try {
    const { width } = formatSpecifier(value);

    if (
      width !== undefined &&
      (!Number.isFinite(width) ||
        !Number.isInteger(width) ||
        width < 0 ||
        width > VEGA_LITE_MAX_NUMERIC_FORMAT_WIDTH)
    ) {
      return {
        kind: 'width',
        message: `Numeric format width must be a whole number from 0 to ${VEGA_LITE_MAX_NUMERIC_FORMAT_WIDTH}; this one is ${width}.`,
      };
    }
  } catch {
    return {
      kind: 'syntax',
      message: `Use a valid D3 numeric format string, such as ".2f" or ",.0f", with a width of at most ${VEGA_LITE_MAX_NUMERIC_FORMAT_WIDTH}.`,
    };
  }

  return undefined;
}
